/*
 * Copyright (c) 2025. Haodong JU
 */

import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import GlobalConfig from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'

const path = 'membership/system'

const entity = {

}

const config = {
  load: async function (filter) {
    return (await hillo.get(cloudV2Url + path + '/bl/' + GlobalConfig.blId))
  },
  add: async function (item) {
    item.blId = GlobalConfig.blId
    return (await hillo.jsonPost(cloudV2Url + path, {
      ...item
    })).content
  },
  edit: async function (item) {
    return (await hillo.jsonPost(cloudV2Url + path, {
      ...item
    })).content
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function getMembershipSystem () {
  return (await hillo.get(cloudV2Url + path + '/bl/' + GlobalConfig.blId))
}

export async function updateMembershipSystem (item) {
  return (await hillo.jsonPost(cloudV2Url + path, {
    ...item
  })).content
}
